import { FC } from 'react';

import { GiftBrandDeliveryManagePage } from '@service/giftBrand/page/GiftBrandDeliveryManagePage';
import StatPageSideBar from '@shared/components/StatPageSideBar';

import { useTitleHook } from '../../bugo/hooks/useTitleHook';

// 관리자·공급사와 같은 배송관리 화면을 쓴다 — 본인 상조 건만(bugo-agency-admin owningFilter), 조회 전용
const AgencyAdminGiftDeliveryContent: FC = function AgencyAdminGiftDeliveryContent() {
  useTitleHook('배송상품 관리');
  return <GiftBrandDeliveryManagePage viewer="agency" />;
};

export const AgencyAdminGiftDeliveryManagementPage: FC = () => (
  <div className="flex">
    <div className="flex flex-col">
      <StatPageSideBar />
    </div>
    <div className="mx-auto max-w-screen-2xl flex-1">
      <div className="py-8 px-10">
        <AgencyAdminGiftDeliveryContent />
      </div>
    </div>
  </div>
);
